import { useEffect } from "react";
import { createGlobalStyle } from "styled-components";

// TEXT

// STYLES
export const DesignLanguageStyleSheet = createGlobalStyle`
  /* --- GLOBAL STYLES --- */
  html,
  body {
    color: var(--shade-0);
    background-color: var(--shade-950);
    font-family: "forma-djr-display", sans-serif;
    width: 100%;
    height: 100%;
  }

  #root {
    display: flex;
    min-height: 100%;
    flex-flow: column;
  }

  /* --- RESET STYLES --- */
  /* These first 9 are from Josh Comeau at @ https://www.joshwcomeau.com/css/custom-css-reset/ */
  /* 1. Use a more-intuitive box-sizing model */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /* 2. Remove default margin */
  * {
    margin: 0;
  }

  /* 3. Enable keyword animations */
  @media (prefers-reduced-motion: no-preference) {
    html {
      interpolate-size: allow-keywords;
    }
  }

  body {
    /* 4. Add accessible line-height */
    line-height: 1.5;
    /* 5. Improve text rendering */
    -webkit-font-smoothing: antialiased;
  }

  /* 6. Improve media defaults */
  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  /* 7. Avoid text overflows */
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }

  /* 8. Improve line wrapping */
  p {
    text-wrap: pretty;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    text-wrap: balance;
  }

  /* 9. Remove default focus outlines */
  :focus {
    outline: none;
  }

  /* 10. Remove default styles for form controls */
  input,
  button,
  textarea,
  select {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    color: inherit;
    resize: none;
    /* background/border resets alone don't stop Safari's native control tint; appearance does. */
    appearance: none;
    -webkit-appearance: none;
  }
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS
export const PreloadFormaFonts = () => {
  const FONT_FAMILY = "forma-djr-display";
  const FONT_SIZE = "1rem"; // arbitrary, needed to load the font properly

  // Add all font weights used in DL4
  const FONT_WEIGHTS = [500, 600, 700, 800] as const;
  useEffect(() => {
    if (!("fonts" in document)) return;
    const loaders = FONT_WEIGHTS.map((weight) => {
      return document.fonts.load(`${weight} ${FONT_SIZE} "${FONT_FAMILY}"`);
    });
    Promise.all(loaders).catch(() => {
      // fail silently
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

// ASSETS
